<div class="container">
  <div
    class="con-site-details"
    *ngIf="selectedNodeItem?.id"
    [ngClass]="{
      'details-opened': detailsOpened,
      'details-closed': !detailsOpened
    }"
  >
    <div>
      <b>{{ (this.state.selectedConSite$ | async)?.name }}</b>

      <div (click)="openMap()" style="cursor: pointer">
        {{ (this.state.selectedConSite$ | async)?.address }}
      </div>
      <div (click)="openMap()" style="cursor: pointer">
        {{ (this.state.selectedConSite$ | async)?.postalCode }}
        {{ (this.state.selectedConSite$ | async)?.city }}
      </div>
      <div
        (click)="openPhone(conSite?.phone1)"
        style="cursor: pointer"
        *ngIf="detailsOpened"
      >
        {{ (this.state.selectedConSite$ | async)?.phone1
        }}<span *ngIf="(this.state.selectedConSite$ | async)?.contactName1">
          ({{ (this.state.selectedConSite$ | async)?.contactName1 }})</span
        >
      </div>
      <div
        (click)="openPhone(conSite?.phone2)"
        style="cursor: pointer"
        *ngIf="detailsOpened"
      >
        {{ (this.state.selectedConSite$ | async)?.phone2
        }}<span *ngIf="(this.state.selectedConSite$ | async)?.contactName2">
          ({{ (this.state.selectedConSite$ | async)?.contactName2 }})</span
        >
      </div>
      <div
        (click)="openMail(conSite?.email1)"
        style="cursor: pointer"
        *ngIf="detailsOpened"
      >
        {{ (this.state.selectedConSite$ | async)?.email1 }}
      </div>
      <div
        (click)="openMail(conSite?.email2)"
        style="cursor: pointer"
        *ngIf="detailsOpened"
      >
        {{ (this.state.selectedConSite$ | async)?.email2 }}
      </div>
    </div>
    <div class="context-container">
      <ion-icon
        (click)="openContextMenu($event)"
        name="ellipsis-vertical-outline"
        style="font-size: 22px"
      ></ion-icon>

      <ion-icon
        *ngIf="!detailsOpened"
        (click)="detailsOpened = true"
        name="caret-down-outline"
        style="font-size: 22px"
      ></ion-icon>
      <ion-icon
        *ngIf="detailsOpened"
        (click)="detailsOpened = false"
        name="caret-up-outline"
        style="font-size: 22px"
      ></ion-icon>
    </div>
  </div>
  <div
    class="whatever"
    *ngIf="!selectedNodeItem?.id"
    [ngClass]="{
      'details-opened': detailsOpened,
      'details-closed': !detailsOpened
    }"
  >
    <div><b>Baustelleninfos:</b></div>
    <div>Keine Baustelle ausgewählt</div>
  </div>
  <div class="upload-buttons">
    @if(currentFolder()?.id == null && state.userHasMinType(1) &&
    selectedNodeItems.length == 0){
    <ion-button (click)="this.state.openConstructionSiteAlert()"
      >Neue Baustelle</ion-button
    >
    } @if(child?.breadcrumbs.length > 1 && selectedNodeItems.length > 0 &&
    state.userHasMinType(1)){
    <ion-button (click)="child?.openMoveFolderModal()"
      ><ion-icon size="small" name="folder-open-outline" slot="start"></ion-icon
      >Verschieben
    </ion-button>
    } @if(selectedNodeItems.length == 1 && state.userHasMinType(1)){
    <ion-button (click)="child?.renameFolder()"
      ><ion-icon size="small" name="create-outline" slot="start"></ion-icon
      >Bearbeiten
    </ion-button>
    } @if(child?.breadcrumbs.length > 1 && selectedNodeItems.length > 0 &&
    state.userHasMinType(1)){
    <ion-button color="danger" (click)="child?.deleteNodes()"
      ><ion-icon size="small" name="trash-outline"></ion-icon>
    </ion-button>
    } @if(currentFolder()?.id != null && selectedNodeItems.length == 0){
    <ion-button (click)="openFileInput()"
      ><ion-icon
        name="cloud-upload-outline"
        slot="start"
        size="small"
      ></ion-icon
      >Dokumente hochladen</ion-button
    >
    <input
      type="file"
      id="file"
      class="hidden"
      (change)="fileInput($any($event.target).files)"
      [accept]="state.supportedFileTypes.join(',')"
      multiple
    />
    } @if(child?.breadcrumbs.length == 1 && selectedNodeItems.length > 0 &&
    state.userHasMinType(1) && selectedNodeItems[0].state != 1){
    <ion-button (click)="archiveConSites()"
      ><ion-icon size="small" slot="start" name="archive-outline"></ion-icon
      >Archivieren
    </ion-button>
    } @if(child?.breadcrumbs.length == 1 && selectedNodeItems.length > 0 &&
    state.userHasMinType(1) && selectedNodeItems[0].state != 0){
    <ion-button (click)="activateConSites()"
      ><ion-icon
        size="small"
        slot="start"
        name="checkmark-circle-outline"
      ></ion-icon
      >Aktivieren
    </ion-button>
    }
    <!--ion-button
      (click)="openCamera()"
      *ngIf="selectedNodeItemId != magicNumber && selectedNodes.length == 0"
      ><ion-icon
        size="small"
        
        name="camera-outline"
      ></ion-icon>
    </ion-button-->
    <ion-button
      (click)="child?.addFolder()"
      *ngIf="
        currentFolder()?.id != null &&
        selectedNodeItems.length == 0 &&
        state.userHasMinType(1)
      "
      >Neuer Ordner</ion-button
    >
  </div>

  <lib-file-tree
    [conSitesMode]="true"
    (selectedNodeItemsChanged)="selectedNodeItemsChanged($event)"
    (currentFolderNodeItemChanged)="currentFolderNodeItemChanged($event)"
    (openFile)="openFile($event)"
    style="width: 100%"
  ></lib-file-tree>
</div>
